import styled from 'styled-components';

export const LayoutContainer = styled.div`
  /* margin-top: 103px; */
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1250px;

  @media (min-width: 768px) {
    margin: 0 0 48px;
  }

  @media (min-width: 993px) {
    padding-top: 56px; 
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    margin: 16px auto 64px;
    max-width: 1314px;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
  padding: 0 16px;
  max-width: 100%;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 0 32px;
  }

  @media (min-width: 1024px) {
    max-width: calc(100% - 310px);
  }
`;

export const RightColumn = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
    flex: 0 0 310px;
    box-sizing: border-box;
  }
`;

export const MetaInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 18px;
`;

export const MetaItem = styled.div<{$hide?: string}>`
  display: flex;
  align-items: center;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.5);
  line-height: 1.25;
  letter-spacing: -0.36px;
  padding: 0 12px;
  border-right: 1px solid rgba(0, 0, 0, 0.5);

  &:first-of-type {
    padding-left: 0;
  }

  &:last-child {
    border-right: none;
  }

  ${({ $hide }) => $hide && $hide == 'mobile' && `
    display: none;

    @media (min-width: 768px) {
      display: flex;
    }
  `}
`;

export const MetaLink = styled.a`
  cursor: pointer;
  font-size: 16px;
  text-decoration: none;
  color: #1b8efb;
  line-height: 1.25;
  letter-spacing: -0.36px;
  &:hover {
    color: #444;
  }

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const MetaDate = styled.span`
  font-size: 16px;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.5);
  line-height: 1.25;
  letter-spacing: -0.36px;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const MetaTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 18px;
  color: grey;
  margin-top: 20px;
`;

export const MetaTag = styled.a`
  cursor: pointer;
  padding: 0.25em 1em;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-size: clamp(14px, 1.5vw, 18px);
  font-style: normal;
  font-weight: 400;
  line-height: 37px;
  letter-spacing: -0.27px;
  text-decoration: none;
  height: 37px;
  flex-shrink: 0;
  border-radius: 100px;
  background: rgba(196, 196, 196, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: #333;
  }
`;

export const HeroBanner = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
  margin-top: 24px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  font-size: 1em;
  line-height: 1.6;
  margin-bottom: 20px;

  p, ul, ol, li, figcaption {
    font-weight: 400;
    color: rgba(0, 0, 0, 0.80);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: -0.27px;

    @media (min-width: 768px) {
      font-size: 18px;
    }
  }

  img {
    max-width: 100%;
    height: auto;
    vertical-align: bottom;
  }

  figure {
    margin: 0;

    a {
      display: block;
    }
  }
`;

export const Eyebrow = styled.p`
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.30);

  @media (min-width: 768px) {
    font-size: 16px;
  }

  a {
    font-size: 14px;
    text-decoration: none;
    color: rgba(27, 142, 251, 0.50);

    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
`;

export const Title = styled.h1`
  margin: 18px 0;
  color: #000;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.72px;

  @media (min-width: 768px) {
    font-size: 48px;
    margin-top: 24px;
  }
`;